export const originOf = data => {
  if (!data) return null
  const remedial = (data.remedials || []).find(r => r.relation === 'handles' && r.source === 'converted')
  if (remedial) {
    return {
      remedial,
      document: remedial.sourceFileId && remedial.sourceFileName
        ? { fileId: remedial.sourceFileId, name: remedial.sourceFileName }
        : null,
    }
  }
  const document = (data.documents || []).find(d => d.isSource)
  return document ? { remedial: null, document } : null
}
